<nb-card class="copy-store-card">
  <nb-card-header>
    <span>Copy Store</span>
    <button nbButton ghost status="basic" (click)="dismiss()" class="close-btn">
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body>
    <p class="source-label">
      Source store: <strong>{{ storeName }}</strong>
    </p>

    <nb-form-field *ngIf="!loading && !polling">
      <label class="field-label">New store name</label>
      <input
        nbInput
        fullWidth
        placeholder="Enter new store name"
        [formControl]="newStoreName"
        [status]="newStoreName.invalid && newStoreName.touched ? 'danger' : 'basic'"
      />
      <p *ngIf="newStoreName.invalid && newStoreName.touched" class="error-hint">
        Store name is required.
      </p>
    </nb-form-field>

    <!-- Initial POST in-flight -->
    <div *ngIf="loading" class="copy-progress-section">
      <p class="progress-status">
        <nb-icon icon="sync-outline"></nb-icon>
        Starting copy job...
      </p>
    </div>

    <!-- Polling: show live progress -->
    <div *ngIf="polling" class="copy-progress-section">
      <p class="progress-status">
        <nb-icon icon="sync-outline"></nb-icon>
        Copying store in background…
      </p>

      <ng-container *ngIf="progress">
        <!-- Categories stage -->
        <p *ngIf="progress.stage === 'store'">
          Initialising store structure...
        </p>
        <p *ngIf="progress.stage === 'categories'">
          Copying categories: {{ progress.categoriesDone }} / {{ progress.categoriesTotal }}
        </p>
        <p *ngIf="progress.stage === 'products' || progress.stage === 'done'">
          Categories: {{ progress.categoriesTotal }} / {{ progress.categoriesTotal }} ✓
        </p>
        <p *ngIf="progress.stage === 'products'">
          Copying products: {{ progress.productsDone }} / {{ progress.productsTotal }}
        </p>

        <!-- Simple progress bar (no NbProgressBarModule needed) -->
        <div *ngIf="progress.productsTotal > 0" class="progress-bar-wrap">
          <div
            class="progress-bar-fill"
            [style.width.%]="(progress.productsDone / progress.productsTotal) * 100"
          ></div>
        </div>

        <p *ngIf="progress.imagesCopied != null" class="images-info">
          Images: {{ progress.imagesCopied }} copied<span *ngIf="progress.imagesFailed > 0">, {{ progress.imagesFailed }} failed</span>
        </p>
      </ng-container>
    </div>

    <p class="copy-info" *ngIf="!loading && !polling">
      <nb-icon icon="info-outline"></nb-icon>
      This will copy all categories, products, and settings. Images will be duplicated.
      This may take a few seconds.
    </p>
  </nb-card-body>

  <nb-card-footer class="dialog-footer">
    <button nbButton status="basic" (click)="dismiss()" [disabled]="loading || polling">
      Cancel
    </button>
    <button
      nbButton
      status="primary"
      (click)="confirm()"
      [disabled]="loading || polling"
      [nbSpinner]="loading"
      nbSpinnerStatus="basic"
    >
      <nb-icon *ngIf="!loading && !polling" icon="copy-outline"></nb-icon>
      {{ loading ? 'Starting...' : polling ? 'Copying...' : 'Copy Store' }}
    </button>
  </nb-card-footer>
</nb-card>
